import Route from '@ember/routing/route';
import { type Registry as Services, service } from '@ember/service';
import dayjs from 'dayjs';
import {
  getDayjsLocale,
  getPreferredLanguage,
  getTranslationLocale,
} from 'frontend-utils/utils/language-preference';

export default class ApplicationRoute extends Route {
  @service declare intl: Services['intl'];
  @service declare session: Services['session'];
  @service declare usageAnalytics: Services['usage-analytics'];

  async beforeModel(): Promise<void> {
    await this.session.setup();

    // Initialize analytics tracking
    this.usageAnalytics.initialise();

    const preferredLanguage = getPreferredLanguage();
    const translationLocale = getTranslationLocale(preferredLanguage);
    const dayjsLocale = getDayjsLocale(preferredLanguage);

    // Set intl locale for translations
    this.intl.setLocale(translationLocale);

    // Set dayjs locale for date formatting
    dayjs.locale(dayjsLocale);
  }
}
